import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Icon,
  Input,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import MicRoundedIcon from "@mui/icons-material/MicRounded";
import RecordRTC, { StereoAudioRecorder } from "recordrtc";
import axios from "axios";
import "../AudioRecorder/recorderstyle.css";
import { ContextApi } from "../../App";
import { toast } from "react-toastify";
import AvatarWithStatus from "../views/AvtarwithStatus";
import ChatBubble from "../views/ChatItem";
import { Flag, Refresh } from "@mui/icons-material";
import { endpoint, wsorigin } from "../../resource/Constant";
import "./websocket.css";
import { useLocation, useNavigate } from "react-router";

function WebSocketImpl({
  interview,
  user_email,
  password,
  startRecordingVideo,
  fullscrnhandle,
  setWsState,
}) {
  // const [ifram, setIframe] = useState();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [timer, setTimer] = useState("00:00:00");
  const timerRef = useRef(null);
  const [currentQuestion, setCurrentQuestion] = useState();
  const [loadingTranscript, setLoadingTranscript] = useState(false); // false
  const [rtcMediaStream, setRtcMediaStream] = useState();
  const [recordingStarted, setRecordingStarted] = useState(false); // false
  const [ws, setWs] = useState();
  const [message, setMessage] = useState();
  const messageDiv = useRef();
  const [connected, setConnected] = useState(false); // false
  const [messages, setMessages] = useState([]);
  const [queAns, setqueAns] = useState(false); // false
  const [loading, setLoading] = useState(false); // false
  const [error, setError] = useState("");
  const [mediatStreamText, setmediaStreamText] = useState();
  const audioPlayer = useRef();
  let rtcmediaStreamFile = useRef(null);
  const voiceId = "bIHbv24MWmeRgasZH58o";
  const apiKey = "sk_fcf3d3079596d310585e7811fad103cbc70d9e3d3030123f";
  const voiceSettings = {
    stability: 0.5,
    similarity_boost: 0.8,
    use_speaker_boost: true,
  };
  const videoRef = useRef();
  const errorKey = "ZXJyb3I6Og==";
  const { totalFaces, setTotalFaces } = useContext(ContextApi);
  const cameraErrorCount = useRef(0);
  const navigate = useNavigate();
  const [isFocus, setIsFocused] = useState();
  const [focusError, setFocusError] = useState(7);
  //Changes the heigth of the questions dynamically using MinHeight
  const MinHeight = isSmallScreen
    ? "250px"
    : isMediumScreen
    ? "350px"
    : isLargeScreen
    ? "450px"
    : "600px";
  // const maxHeight = isSmallScreen? "250px" : isMediumScreen? "200px" : isLargeScreen? "600px" : "600px";

  //timer for recorder

  const isJsonString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
  const connectToSocket = () => {
    // const websocket = new WebSocket(
    //   `ws://localhost:8000/ws/${Math.floor(Math.random() * 99999)}`
    if (ws) {
      if (ws.readyState === WebSocket.CLOSING) {
        return;
      }
    }
    fullscrnhandle.enter();
    getVideo();
    startRecordingVideo();

    const websocket = new WebSocket(
      `${wsorigin}/ws/v2/${interview}/${user_email}/${password}`
    );
    websocket.onmessage = (e) => {
      if (isJsonString(e.data)) {
        const question_object = JSON.parse(e.data);
        if (question_object?.question) {
          setCurrentQuestion(question_object);
          setMessages((prev) => [...prev, question_object?.question]);
          startStreaming(question_object?.question);
        }
      } else {
        if (e.data != "Answer received.") {
          if (cameraErrorCount.current > 10) {
            websocket.close();
            setConnected(false);
            setRecordingStarted(false);
            cameraErrorCount.current = 0;
          }
          if (
            e.data == "Thank you for your time, We are Done with the interview."
          ) {
            toast.success(e.data, {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "error1",
            });
            websocket.close();
            navigate(-1);
          }
          if (e.data == "Interview Expired") {
            toast.warn(e.data, {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "error1",
            });
            websocket.close();
            navigate(-1);
          }
          {
            toast.warn(e.data, {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "error1",
            });
          }
        } else {
          setMessages((prev) => [...prev, e.data]);
        }
      }
    };
    websocket.onclose = () => {
      setWsState(false);
    };
    websocket.onopen = () => {
      setConnected(true);
    };
    setWs(websocket);
  };

  const sendMessage = () => {
    stopRecording();
    // if (ws) {
    //   ws.send(message);
    //   setMessage("");
    // }
  };

  useEffect(() => {
    messageDiv.current.scrollTop = messageDiv.current.scrollHeight;
  }, [messages]);

  const startStreaming = async (text) => {
    setLoading(true);
    setError("");

    try {
    } catch (error) {
      setError("Error: Unable to stream audio.");
    } finally {
      setLoading(false);
      startRecording();
      // while (!audio.ended) {
      // }
    }
  };

  const startRecording = () => {
    navigator.getUserMedia(
      {
        audio: true,
      },
      function (stream) {
        //5)
        setRtcMediaStream(
          RecordRTC(stream, {
            type: "audio",

            //6)
            mimeType: "audio/webm",
            sampleRate: 44100,
            // used by StereoAudioRecorder
            // the range 22050 to 96000.
            // let us force 16khz recording:
            desiredSampRate: 16000,

            // MediaStreamRecorder, StereoAudioRecorder, WebAssemblyRecorder
            // CanvasRecorder, GifRecorder, WhammyRecorder
            recorderType: StereoAudioRecorder,
            // Dialogflow / STT requires mono audio
            numberOfAudioChannels: 1,
          })
        );
        setRecordingStarted(true);
      },
      function (error) {
        const response = alert(
          "⚠️ Permissions Required To proceed, we need access to your camera and microphone. 🔒 Privacy First: Your data is secure and used only for its intended purpose."
        );
        startRecording();
      }
    );
  };

  const sendFocusError = () => {
    if (ws) {
      if (focusError == 0) {
        ws.close();
        setConnected(false);
        setRecordingStarted(false);
        navigate("/");
      } else {
        setFocusError((prev) => prev - 1);
      }
    }
  };

  const sendCameraError = (faces) => {
    if (ws) {
      if (ws.readyState === WebSocket.OPEN) {
        if (totalFaces == 0) {
          ws.send(errorKey + "Number of faces found:" + faces);
          cameraErrorCount.current += 1;
        } else if (totalFaces > 1) {
          ws.send(errorKey + "Number of faces found:" + faces);
          cameraErrorCount.current += 1;
        }
      }
    }
  };
  useEffect(() => {
    const handleFocus = () => {
      setIsFocused(true);
    };

    // Handle window blur
    const handleBlur = () => {
      setIsFocused(false);
    };

    // Add event listeners for focus and blur
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  }, []);

  useEffect(() => {
    sendFocusError();
  }, [isFocus]);
  useEffect(() => {
    sendCameraError(totalFaces);
  }, [totalFaces]);

  useEffect(() => {
    if (rtcMediaStream) {
      rtcMediaStream.startRecording();
      clearTimer(getDeadTime());
    }
  }, [rtcMediaStream]);

  const stopRecording = () => {
    setRecordingStarted(false);
    setLoadingTranscript(true);
    rtcMediaStream.stopRecording(function () {
      setRecordingStarted(false);
      // after stopping the audio, get the audio data
      rtcMediaStream.getDataURL(function (audioDataURL) {
        //2)
        var files = {
          audio: {
            type: rtcMediaStream.getBlob().type || "audio/wav",
            dataURL: audioDataURL,
          },
        };
        rtcmediaStreamFile = files;
        // submit the audio file to the server
        const formData = new FormData();
        formData.append("blob_file", rtcMediaStream.getBlob(), "recording.wav");
        axios
          .post(
            endpoint + "/api/question/uploadanswer/" + currentQuestion?.id,
            formData
          )
          .then((res) => {
            if (ws) {
              ws.send(res.data);
              setMessage("");
            }
            setRecordingStarted(false);
            setLoadingTranscript(false);
            setRtcMediaStream(null);
          })
          .catch((e) => {
            alert(e.response.data.detail + ",Please retry.");
            setRecordingStarted(false);
            setLoadingTranscript(false);
            startRecording();
          });
      });
    });
  };

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    if (total + hours + minutes + seconds == 0) {
      stopRecording();
    }
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (hours > 9 ? hours : "0" + hours) +
          ":" +
          (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    }
  };

  const clearTimer = (e) => {
    setTimer("00:05:00");
    if (timerRef.current) clearInterval(timerRef.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    timerRef.current = id;
  };
  const getDeadTime = () => {
    const total_time = 5 * 60;
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + total_time);
    return deadline;
  };

  const getVideo = async () => {
    const startWebRTC = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { width: 1280, height: 720 },
        });
        if (videoRef.current) {
          videoRef.current = stream;
        }
      } catch (err) {
        alert(
          "⚠️ Permissions Required To proceed, we need access to your camera and microphone. 🔒 Privacy First: Your data is secure and used only for its intended purpose."
        );
        getVideo();
      }
    };
    startWebRTC();
  };

  return (
    <>
      <div
        className="messaging"
        style={{
          background: "white",
          // border: "2px solid black",
          borderRadius: "15px",
          marginTop: "25px",
          boxShadow:
            "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
          minHeight: `${MinHeight}`,
          // maxHeight : `${maxHeight}`,
          padding: "10px",
        }}
      >
        <div
          style={{
            color: "#007e94",
            fontSize: `${
              isSmallScreen
                ? "10px"
                : isMediumScreen
                ? "15px"
                : isLargeScreen
                ? "20px"
                : "25px"
            }`,
          }}
        >
          {messages.length > 0 ? (
            <b>Questions</b>
          ) : (
            <b>Questions will Appear Here!</b>
          )}
        </div>
        <Grid pt={2} height={"100%"}>
          <Grid>
            <div
              ref={messageDiv}
              style={{
                overflowX: "hidden",
                overflowY: "auto",
                maxHeight: isSmallScreen
                  ? 200
                  : isMediumScreen
                  ? 250
                  : isLargeScreen
                  ? 290
                  : 380,
              }}
            >
              {/* <Box
            sx={{
              // display: "flex",
              // flex: 1,
              minHeight: 0,
              px: 2,
              py: 3,
              overflowY: "scroll",
              flexDirection: "column-reverse",
            }}
          > */}
              <Stack spacing={2} sx={{ justifyContent: "flex-end" }}>
                {messages.map((message, index) => {
                  return (
                    <Stack
                      key={index}
                      direction="row"
                      spacing={2}
                      sx={{ flexDirection: "row" }}
                    >
                      {<AvatarWithStatus online={true} src={undefined} />}
                      <ChatBubble
                        variant={"received"}
                        sender={{ name: "A.I." }}
                        // timestamp={new Date().toUTCString()}
                        content={message}
                      />
                    </Stack>
                  );
                })}
              </Stack>
            </div>
          </Grid>
          <Grid>
            <div>
              <button
                onClick={startStreaming}
                disabled={loading}
                style={{ display: "none" }}
              >
                Start Streaming
              </button>
              {error && <p>{error}</p>}
            </div>
            {/* <Input
            type="text"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
          ></Input> */}
          </Grid>
          <div style={{}}>
            <div
              style={{
                display: "flex",
                // marginLeft : "35px",
              }}
            >
              {loadingTranscript && (
                <>
                  <svg width={0} height={0}>
                    <defs>
                      <linearGradient
                        id="my_gradient"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                      >
                        <stop offset="0%" stopColor="#e01cd5" />
                        <stop offset="100%" stopColor="#1CB5E0" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <CircularProgress
                    sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
                    size={50}
                    thickness={2}
                  />
                </>
              )}
            </div>
            {/* <Grid container alignItems={"center"}> */}
            <Grid
              item
              container
              xs={loadingTranscript ? 12 : 12}
              sx={{ mt: "20px" }}
            >
              {recordingStarted && (
                <>
                  <div>
                    <Grid className="animation-circle ">
                      <Icon>
                        <MicRoundedIcon />
                      </Icon>
                    </Grid>
                  </div>
                  <Grid item md={9} sm={9} xs={9}>
                    <Typography variant="h5" textAlign={"left"}>
                      {timer}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item xs={10}>
              <Button
                sx={{
                  display: !connected || !recordingStarted ? "none" : "block",
                  backgroundImage:
                    "var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))",
                  maxWidth: `${
                    isSmallScreen
                      ? "80px"
                      : isMediumScreen
                      ? "150px"
                      : isLargeScreen
                      ? "200px"
                      : "250px"
                  }`,
                  borderRadius: "15px",
                  color: "white",
                  mt: "10px",
                  "&:hover": {
                    backgroundColor: "rgb(119, 141, 169)",
                    color: "rgb(224, 225, 221)",
                    boxShadow: "0 4px 4px 2px rgba(0, 0, 0, 0.2)",
                  },
                }}
                p={1}
                fullWidth
                variant="contained"
                onClick={sendMessage}
              >
                Submit Answer
              </Button>
            </Grid>
          </div>
          <Grid></Grid>
          <Backdrop
            sx={(theme) => ({
              background: "#E0E1DD",
              color: "#fff",
              zIndex: theme.zIndex.drawer + 1,
            })}
            open={!connected}
            // open={false}
          >
            <Grid
              container
              alignItems="center"
              boxShadow={3}
              sx={{
                background: "white",
                borderRadius: "5px",
                boxSizing: "border-box",
                borderWidth: "4px",
                borderStyle: "solid",
                width: { xs: "300px", sm: "500px" },
                borderRadius: "10px",
                transformStyle: "preserve-3d",
                p: "10px",
              }}
              justifyContent="center"
            >
              <Grid xs={12} sm={12} md={8} sx={{ color: "red" }}>
                <Typography variant="h7">
                  <b>1. Do not refresh the page or navigate away</b> – this will
                  pause the interview.
                  <br />
                  <b>2. Do not switch between tabs</b> – switching tabs will
                  pause the interview.
                  <br />
                  <b>3. Face detection is mandatory</b> – having no face or
                  multiple faces detected will result in the interview being
                  paused.
                  <br />
                  <b>4. Permission to record</b> – by starting the interview,
                  you are granting permission to record both audio and video.
                  <br />
                  <b>5. Time limit</b> – you will have a two-hour window once
                  you start the interview.
                </Typography>
              </Grid>
              <Grid xs={12} sx={{ p: "10px" }}>
                <Button
                  disabled={connected}
                  p={1}
                  variant="contained"
                  sx={{
                    backgroundImage:
                      "var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "rgb(119, 141, 169)",
                      color: "rgb(224, 225, 221)",
                      boxShadow: "0 4px 4px 2px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                  onClick={connectToSocket}
                >
                  Start Interveiw
                </Button>
              </Grid>
            </Grid>
          </Backdrop>
        </Grid>
      </div>
    </>
  );
}

export default WebSocketImpl;
